import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import EmailPulseDataGrid from '../../email-pulse-data-grid/email-pulse-data-grid.component';
import {
  getMessagesDataGridColumns,
  messagesColumnVisibilityModel,
} from '../messages.config';
import { EmailPulseExportMutationHook } from '../../email-pulse.types';

type MessagesDataGridProps = {
  'data-testid': string;
  queryName: string;
  useExportMutation: EmailPulseExportMutationHook;
};

/**
 * Messages tab data grid component.
 * Wrapper around the generic EmailPulseDataGrid with Messages-specific configuration.
 */
const MessagesDataGrid = ({
  queryName,
  useExportMutation,
  ...rest
}: MessagesDataGridProps) => {
  const { t } = useTranslation();

  const columns = useMemo(() => getMessagesDataGridColumns(t), [t]);

  return (
    <EmailPulseDataGrid
      columns={columns}
      columnVisibilityModel={messagesColumnVisibilityModel}
      exportFileType="MESSAGES"
      queryName={queryName}
      useExportMutation={useExportMutation}
      pinnedLeftColumn="title"
      {...rest}
    />
  );
};

export default MessagesDataGrid;
